export default __webpack_public_path__ + "static/media/solar-panel.dc73f5da.svg";